import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import { ElMessage } from 'element-plus';

const TOKEN_KEY = 'dm-coop-pc-token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const request: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE
    ? `${import.meta.env.VITE_API_BASE}/api/v1`
    : '/api/v1',
  timeout: 15000,
});

request.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message || error.message || '请求失败';

    if (status === 401) {
      ElMessage.error('请重新登录');
      clearToken();
      setTimeout(() => location.reload(), 1000);
    } else if (status >= 500) {
      ElMessage.error('服务异常，请稍后再试');
    } else if (status) {
      ElMessage.error(message);
    }
    return Promise.reject(error);
  },
);

// ===== 通用请求方法 =====
// response 拦截器已把 AxiosResponse 解包为 data，故返回类型手动断言为业务类型 T
export function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return request.get(url, config) as unknown as Promise<T>;
}

export function post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  return request.post(url, data, config) as unknown as Promise<T>;
}

export function patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  return request.patch(url, data, config) as unknown as Promise<T>;
}

export function del<T = void>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return request.delete(url, config) as unknown as Promise<T>;
}

// ===== 业务 API 统一出口（视图通过 `import { itemsApi } from '@/api'` 使用）=====
export * from './items';
export * from './projects';
export * from './tags';
export * from './comments';